import { Button , Col, Nav, Row} from "react-bootstrap";
import "../styles/leftsidebar.scss";
import { useNavigate,NavLink, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import Modal from 'react-bootstrap/Modal';
import { toast } from "react-toastify";
import axios from "axios";
import { deleteCookie, getNewToken } from "../config/cookie.config";
const LeftSidebar = () => {
    const [isToggled, setIsToggled] = useState(false);
    const user = JSON.parse( window.localStorage.getItem('client'));
    var userrole;
    let token;
    if(user !== null){
         userrole = user.user.role;
         token = user.token
    }else{
         userrole = null;
         token = null;
    }
	
    const [role] = useState(userrole);
    const navigate = useNavigate();
    const logout = async () => {
        await axios.post(`${process.env.REACT_APP_BACKEND_BASE_URL}api/user/logout`, {}, { // Empty object for body
            headers: {
              'Authorization': `Bearer ${getNewToken()}`
            }
          }).then((res)=> {
            toast.success("You are Successfully Logged Out")
            setTimeout(() => {
                localStorage.removeItem('client');
                localStorage.removeItem('user');
                localStorage.removeItem('admin_email');
                 // Delete cookies
                deleteCookie('OAC-01');
                deleteCookie('AAC-02');
                // Remove token from localStorage
                window.localStorage.removeItem("CAACAO-012");
                navigate('/admin');
                // window.location.reload();
        
            }, 1000);
          }).catch((err)=> {
            console.log('Error :',err);
          })
    }

    
  const [show, setShow] = useState(false);
  const handleClose = () => {
      setShow(false);
    } 
    
  const handleShow = () => {
    setShow(true);
    
  }
    // Implementing auto logout by inactivity
    useEffect(() => {
        let timeoutId;
        function onUserActivity() {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                localStorage.removeItem('client');
                // Delete cookies
                deleteCookie('OAC-01');
                deleteCookie('AAC-02');
                // Remove token from localStorage
                window.localStorage.removeItem("CAACAO-012");
                navigate('/admin');
                toast.error("Session Expired. Please Login Again")
            }, 900000);
        }
        
        function resetTimeout() {
          onUserActivity();
        }
    
        // Events for desktop
        window.addEventListener('mousemove', resetTimeout);
        window.addEventListener('keydown', resetTimeout);
    
        // Events for mobile
        window.addEventListener('touchstart', resetTimeout);
        window.addEventListener('touchmove', resetTimeout);
        window.addEventListener('touchend', resetTimeout);
    
        // Initialize timeout on component mount
        onUserActivity();
    
        // Cleanup event listeners and timeout on component unmount
        return () => {
            // Cleanup
            window.removeEventListener('mousemove', resetTimeout);
            window.removeEventListener('keydown', resetTimeout);
            window.removeEventListener('touchstart', resetTimeout);
            window.removeEventListener('touchmove', resetTimeout);
            window.removeEventListener('touchend', resetTimeout);
            clearTimeout(timeoutId);
        };
    }, [navigate]);

    return (
        <div className={`leftSideBar bg-white position-fixed top-0 left-0 overflow-hidden  ${ isToggled ? '' : 'active' } `}>
            <div className="logoWrapper">
                <Link to='/admin/dashboard'>
                <img
                    // src="/assets/images/logo.png"
                    src="https://ncentiva-development.s3.eu-west-1.amazonaws.com/ncentiva_new_logo.png"
                    alt=""
                    className="img-fluid my-3"
                    style={{ width: '100%',
                    maxWidth: '170px',
                            marginTop: '10px', }}
                    />
                </Link>
            </div>

            <div>
                <ul className="list-unstyled menuItemWrapper mt-0">
                <li>
                        <Nav.Link
                            as={NavLink}
                            to="/admin/dashboard"
                            className="d-flex align-items-center w-100"
                        >
                            <span className="icon">
                            {/* <svg
                                    width="15"
                                    height="15"
                                    viewBox="0 0 15 15"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M7.03125 1.875V5.15625C7.03073 5.65337 6.83308 6.12996 6.48153 6.48153C6.12997 6.83309 5.65337 7.03074 5.15625 7.03125H1.875C1.37788 7.03073 0.901286 6.83308 0.549723 6.48153C0.198161 6.12997 0.000508929 5.65337 0 5.15625V1.875C0.000523152 1.37788 0.198171 0.901286 0.549723 0.549723C0.901275 0.198161 1.37788 0.000508929 1.875 0H5.15625C5.65337 0.000523152 6.12996 0.198171 6.48153 0.549723C6.83309 0.901275 7.03074 1.37788 7.03125 1.875ZM13.125 0H9.84375C9.34663 0.000523152 8.87004 0.198171 8.51847 0.549723C8.16691 0.901275 7.96926 1.37788 7.96875 1.875V5.15625C7.96927 5.65337 8.16692 6.12996 8.51847 6.48153C8.87003 6.83309 9.34663 7.03074 9.84375 7.03125H13.125C13.6221 7.03073 14.0987 6.83308 14.4503 6.48153C14.8018 6.12997 14.9995 5.65337 15 5.15625V1.875C14.9995 1.37788 14.8018 0.901286 14.4503 0.549723C14.0987 0.198161 13.6221 0.000508929 13.125 0ZM5.15625 7.96875H1.875C1.37788 7.96927 0.901286 8.16692 0.549723 8.51847C0.198161 8.87003 0.000508929 9.34663 0 9.84375V13.125C0.000523152 13.6221 0.198171 14.0987 0.549723 14.4503C0.901275 14.8018 1.37788 14.9995 1.875 15H5.15625C5.65337 14.9995 6.12996 14.8018 6.48153 14.4503C6.83309 14.0987 7.03074 13.6221 7.03125 13.125V9.84375C7.03073 9.34663 6.83308 8.87004 6.48153 8.51847C6.12997 8.16691 5.65337 7.96926 5.15625 7.96875ZM13.125 7.96875H9.84375C9.34663 7.96927 8.87004 8.16692 8.51847 8.51847C8.16691 8.87003 7.96926 9.34663 7.96875 9.84375V13.125C7.96927 13.6221 8.16692 14.0987 8.51847 14.4503C8.87003 14.8018 9.34663 14.9995 9.84375 15H13.125C13.6221 14.9995 14.0987 14.8018 14.4503 14.4503C14.8018 14.0987 14.9995 13.6221 15 13.125V9.84375C14.9995 9.34663 14.8018 8.87004 14.4503 8.51847C14.0987 8.16691 13.6221 7.96926 13.125 7.96875Z"
                                        fill="#FF7020"
                                    />
                                </svg> */}
                                <div className="border p-2 rounded-5 new_icon"></div>
                            </span>
                            <span>Dashboard</span>
                        </Nav.Link>
                    </li>
                    {role === "Admin" ?
                    <li>
                        <Nav.Link
                        as={NavLink}
                            className="d-flex align-items-center w-100"
                            to="/admin/users-management"
                        >
                            <span className="icon">
                            {/* <svg
                                    width="12"
                                    height="15"
                                    viewBox="0 0 12 15"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M6.68426 7.60306H5.04378C3.70605 7.60306 2.42323 8.13447 1.47726 9.08032C0.531294 10.0263 0 11.3093 0 12.647V13.4649C0 13.872 0.161691 14.2625 0.449565 14.5504C0.737459 14.8383 1.12783 15 1.53506 15H10.1931C10.6003 15 10.9907 14.8383 11.2786 14.5504C11.5665 14.2625 11.7282 13.872 11.7282 13.4649V12.647C11.7282 11.3093 11.1969 10.0263 10.2509 9.08032C9.30494 8.13451 8.02211 7.60306 6.68438 7.60306H6.68426Z"
                                        fill="#333333"
                                    />
                                    <path
                                        d="M5.86368 6.95181C6.78564 6.95181 7.66997 6.58544 8.3218 5.93347C8.97363 5.28153 9.33982 4.3972 9.33966 3.47524C9.33935 2.55312 8.97284 1.66911 8.3207 1.01728C7.6686 0.365605 6.78427 -0.000430388 5.86215 3.79781e-07C4.94019 0.000306303 4.05618 0.366979 3.4045 1.01939C2.75299 1.67165 2.38723 2.55614 2.3877 3.4781C2.38953 4.39916 2.75636 5.28207 3.40787 5.93312C4.05939 6.58432 4.9425 6.95052 5.86368 6.95177V6.95181Z"
                                        fill="#333333"
                                    />
                                </svg> */}
                                <div className="border p-2 rounded-5 new_icon"></div>
                            </span>
                            <span>Users Management</span>
                        </Nav.Link>
                    </li>
                    :
                    <li></li>
                    }
                    <li>
                        <Nav.Link
                        as={NavLink}
                            to="/admin/brands"
                            className="d-flex align-items-center w-100"
                        >
                            <span className="icon">
                            {/* <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-ticket-perforated-fill" viewBox="0 0 16 16">
  <path d="M0 4.5A1.5 1.5 0 0 1 1.5 3h13A1.5 1.5 0 0 1 16 4.5V6a.5.5 0 0 1-.5.5 1.5 1.5 0 0 0 0 3 .5.5 0 0 1 .5.5v1.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 11.5V10a.5.5 0 0 1 .5-.5 1.5 1.5 0 1 0 0-3A.5.5 0 0 1 0 6V4.5Zm4-1v1h1v-1H4Zm1 3v-1H4v1h1Zm7 0v-1h-1v1h1Zm-1-2h1v-1h-1v1Zm-6 3H4v1h1v-1Zm7 1v-1h-1v1h1Zm-7 1H4v1h1v-1Zm7 1v-1h-1v1h1Zm-8 1v1h1v-1H4Zm7 1h1v-1h-1v1Z"/>
</svg> */}
                            <div className="border p-2 rounded-5 new_icon"></div>
                            </span>
                            <span>Brands</span>
                        </Nav.Link>
                    </li>
                    <li>
                        <Nav.Link
                        as={NavLink}
                            to="/admin/coupons"
                            className="d-flex align-items-center w-100"
                        >
                            <span className="icon">
                                {/* <svg
                                    width="15"
                                    height="10"
                                    viewBox="0 0 15 10"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M1.02273 0C0.462038 0 0 0.462038 0 1.02273V3.06818C0 3.2564 0.152611 3.40913 0.340948 3.40913C1.09806 3.40913 1.70462 4.01557 1.70462 4.7728C1.70462 5.52991 1.09817 6.13647 0.340948 6.13647C0.152725 6.13647 0 6.28908 0 6.47742V8.52287C0 9.08356 0.462038 9.5456 1.02273 9.5456H3.40913V7.1592C3.40913 6.97098 3.56174 6.81825 3.75007 6.81825C3.9383 6.81825 4.09102 6.97086 4.09102 7.1592V9.5456H13.9773C14.538 9.5456 15 9.08356 15 8.52287V6.47742C15 6.2892 14.8474 6.13647 14.6591 6.13647C13.9019 6.13647 13.2954 5.53003 13.2954 4.7728C13.2954 4.01569 13.9018 3.40913 14.6591 3.40913C14.8473 3.40913 14.9999 3.25651 15 3.06818V1.02273C15 0.462038 14.538 0 13.9773 0H4.09073V2.3864C4.09073 2.57462 3.93812 2.72735 3.74978 2.72735C3.56156 2.72735 3.40883 2.57474 3.40883 2.3864V0H1.02273ZM9.86843 2.08139C10.0369 2.16563 10.1052 2.3704 10.0209 2.53887L7.63453 7.3115C7.55029 7.47997 7.34552 7.54823 7.17705 7.46399C7.00857 7.37976 6.94031 7.17498 7.02455 7.00651L9.41095 2.23389C9.50774 2.04601 9.69368 2.00389 9.86843 2.08139ZM6.81837 2.55681C7.37914 2.55681 7.84109 3.01877 7.84109 3.57954C7.84109 4.14032 7.37914 4.60227 6.81837 4.60227C6.25759 4.60227 5.79564 4.14032 5.79564 3.57954C5.79564 3.01877 6.25759 2.55681 6.81837 2.55681ZM6.81837 3.23859C6.62604 3.23859 6.47742 3.38721 6.47742 3.57954C6.47742 3.77187 6.62603 3.92049 6.81837 3.92049C7.0107 3.92049 7.15932 3.77187 7.15932 3.57954C7.15932 3.38721 7.0107 3.23859 6.81837 3.23859ZM3.75019 3.40901C3.93841 3.40901 4.09114 3.56162 4.09114 3.74996V5.79541C4.09114 5.98363 3.93853 6.13636 3.75019 6.13636C3.56197 6.13636 3.40924 5.98375 3.40924 5.79541V3.74996C3.40924 3.56173 3.56185 3.40901 3.75019 3.40901ZM10.2276 4.9431C10.7883 4.9431 11.2503 5.40505 11.2503 5.96582C11.2503 6.5266 10.7883 6.98855 10.2276 6.98855C9.66678 6.98855 9.20483 6.5266 9.20483 5.96582C9.20483 5.40505 9.66678 4.9431 10.2276 4.9431ZM10.2276 5.62488C10.0352 5.62488 9.8866 5.77349 9.8866 5.96582C9.8866 6.15816 10.0352 6.30677 10.2276 6.30677C10.4199 6.30677 10.5685 6.15816 10.5685 5.96582C10.5685 5.77349 10.4199 5.62488 10.2276 5.62488Z"
                                        fill="#333333"
                                    />
                                </svg> */}
                                <div className="border p-2 rounded-5 new_icon"></div>
                            </span>
                            <span>Gift Cards</span>
                        </Nav.Link>
                    </li>
                    {

                        <li>
                        <Nav.Link
                        as={NavLink}
                            to="/admin/businesspartners"
                            className="d-flex align-items-center w-100"
                        >
                            <span className="icon">
                                {/* <svg
                                    width="17"
                                    height="14"
                                    viewBox="0 0 17 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M10.1632 5.30739H6.41456L5.62543 7.37905L5.30973 6.03749H5.34922C5.4479 6.03749 5.54658 5.93882 5.54658 5.84014V5.46524C5.54658 5.36656 5.4479 5.26788 5.34922 5.26788H4.87567C4.777 5.26788 4.67832 5.36656 4.67832 5.46524V5.84014C4.67832 5.93882 4.777 6.03749 4.87567 6.03749H4.89535L4.57965 7.37905L3.79052 5.30739H3.71166C1.91622 5.30739 1.20595 7.24087 0.831044 8.26685C0.771865 8.40503 0.732367 8.54306 0.692868 8.64176C0.475974 9.19419 0.219424 10.2597 0.0220906 11.0883C-0.0765866 11.5618 0.160266 12.0551 0.633679 12.2523C0.633679 12.2523 0.653359 12.2523 0.653359 12.272C1.22545 12.5087 1.87657 12.1733 2.03441 11.5617C2.21195 10.7134 2.44881 9.82546 2.58684 9.45056C2.64602 9.3322 2.68552 9.17435 2.7447 9.0165L2.80388 12.0352C2.82356 12.5481 3.19844 12.9625 3.69168 13.0217C4.14543 13.0808 4.59933 13.1005 5.07273 13.1005C5.54629 13.1005 6.00004 13.0808 6.45379 13.0217C6.96673 12.9625 7.34159 12.5481 7.34159 12.0352L7.51913 7.3592H8.80149C9.0978 6.70822 9.51219 5.89926 10.1631 5.30737L10.1632 5.30739Z"
                                        fill="#333333"
                                    />
                                    <path
                                        d="M7.48018 2.38738C7.48018 3.70582 6.41139 4.77475 5.09294 4.77475C3.7745 4.77475 2.70557 3.70582 2.70557 2.38738C2.70557 1.06893 3.7745 0 5.09294 0C6.41139 0 7.48018 1.06893 7.48018 2.38738Z"
                                        fill="#333333"
                                    />
                                    <path
                                        d="M16.9789 11.0882C16.7815 10.2399 16.5251 9.19408 16.3081 8.66149C16.2686 8.56281 16.2094 8.42477 16.1699 8.28658C15.795 7.2606 15.0848 5.32711 13.2893 5.32711H13.2105L12.4213 7.39878L12.1056 6.05722H12.1451C12.2438 6.05722 12.3425 5.95855 12.3425 5.85987V5.48497C12.3425 5.38629 12.2438 5.28761 12.1451 5.28761H11.6716C11.5729 5.28761 11.4742 5.38629 11.4742 5.48497V5.85987C11.4742 5.95855 11.5729 6.05722 11.6716 6.05722H11.6913L11.3755 7.39878L10.5864 5.32711H10.5076C8.71212 5.32711 8.00184 7.2606 7.62694 8.28658C7.56776 8.42476 7.52827 8.56279 7.48877 8.66149C7.27173 9.19423 6.99552 10.2596 6.81799 11.108C6.71931 11.5816 6.95616 12.0748 7.42958 12.272H7.44926C8.02135 12.5088 8.69227 12.1734 8.83031 11.5618C9.02766 10.7135 9.2447 9.82551 9.38274 9.45061C9.44192 9.33225 9.48142 9.1744 9.5406 9.01655L9.59978 12.0352C9.61946 12.5481 9.99434 12.9625 10.4876 13.0217C10.9413 13.0809 11.4149 13.1006 11.8686 13.1006C12.3422 13.1006 12.8156 13.0809 13.2695 13.0217C13.7628 12.9625 14.1573 12.5481 14.1573 12.0352L14.2165 9.01655C14.2757 9.17441 14.3349 9.33226 14.3744 9.45061C14.5322 9.82551 14.7493 10.7133 14.9465 11.5618C15.0846 12.1734 15.7356 12.5088 16.3275 12.272H16.3472C16.821 12.0549 17.0774 11.5616 16.9789 11.0882L16.9789 11.0882Z"
                                        fill="#333333"
                                    />
                                    <path
                                        d="M14.2961 2.38738C14.2961 3.70582 13.2272 4.77475 11.9087 4.77475C10.5903 4.77475 9.52148 3.70582 9.52148 2.38738C9.52148 1.06893 10.5903 0 11.9087 0C13.2272 0 14.2961 1.06893 14.2961 2.38738Z"
                                        fill="#333333"
                                    />
                                </svg> */}
                                <div className="border p-2 rounded-5 new_icon"></div>
                            </span>
                            <span>Business Partners</span>
                        </Nav.Link>
                    </li>

                    }
                   

                    <li>
                        <Nav.Link
                        as={NavLink}
                            to="/admin/customers"
                            className="d-flex align-items-center w-100"
                        >
                            <span className="icon">
                                {/* <svg
                                    width="18"
                                    height="15"
                                    viewBox="0 0 18 15"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M10.8419 4.13715C11.0215 4.36869 11.2393 4.56915 11.471 4.71431C11.7924 4.92166 12.1311 5.02885 12.4801 5.02885C13.7727 5.02885 14.7784 3.56347 14.7784 2.30532C14.7784 1.0335 13.7484 0 12.4801 0C11.2083 0 10.1748 1.03337 10.1748 2.30532C10.1748 2.91708 10.4168 3.59104 10.8211 4.11294C10.8246 4.11645 10.8349 4.12673 10.8419 4.13714L10.8419 4.13715Z"
                                        fill="#333333"
                                    />
                                    <path
                                        d="M8.92542 8.42738C8.73712 8.60252 8.53966 8.75621 8.33243 8.88221C7.80992 9.2207 7.23587 9.39759 6.64253 9.39759C5.76449 9.39759 4.97882 9.017 4.35024 8.43117C1.815 9.36727 0 11.8003 0 14.6544C0 14.8479 0.155453 15 0.345644 15H12.9365H12.9434C13.1369 15 13.289 14.8479 13.289 14.6544C13.289 14.6302 13.289 14.606 13.2821 14.5853C13.2524 11.7544 11.4435 9.35249 8.92545 8.42725L8.92542 8.42738Z"
                                        fill="#333333"
                                    />
                                    <path
                                        d="M14.4754 4.77515C13.9546 5.33992 13.2638 5.72026 12.4803 5.72026C11.9992 5.72026 11.5335 5.5771 11.0965 5.29528C10.8784 5.15851 10.6675 4.98012 10.4788 4.7754C10.4648 4.7818 10.4516 4.79007 10.4376 4.79672C10.4413 4.86604 10.4481 4.93449 10.4481 5.00482C10.4481 5.96537 10.0721 7.02958 9.44132 7.85923C9.43455 7.86938 9.42816 7.87527 9.42139 7.88455C10.3315 8.2594 11.1414 8.80736 11.8162 9.48408L16.9351 9.48395C17.1251 9.48395 17.2807 9.32837 17.2807 9.13831C17.2807 7.20382 16.1287 5.53552 14.4753 4.77523L14.4754 4.77515Z"
                                        fill="#333333"
                                    />
                                    <path
                                        d="M6.64284 8.70657C7.10254 8.70657 7.55185 8.56491 7.97346 8.29186C8.29138 8.0983 8.58522 7.82876 8.84437 7.50044C8.85477 7.49004 8.86505 7.47963 8.87208 7.46584C9.42504 6.75039 9.75689 5.83108 9.75689 5.00506C9.75689 3.28733 8.36057 1.89102 6.64285 1.89102C4.92512 1.89102 3.52881 3.28733 3.52881 5.00506C3.52881 6.71579 4.89052 8.7067 6.64285 8.7067L6.64284 8.70657Z"
                                        fill="#333333"
                                    />
                                </svg> */}
                                <div className="border p-2 rounded-5 new_icon"></div>
                            </span>
                            <span>Customers</span>
                        </Nav.Link>
                    </li>

                    <li>
                        <Nav.Link
                        as={NavLink}
                            to="/admin/mails"
                            className="d-flex align-items-center w-100"
                        >
                            <span className="icon">
                                {/* <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512"><path d="M215.4 96H144 107.8 96v8.8V144v40.4 89L.2 202.5c1.6-18.1 10.9-34.9 25.7-45.8L48 140.3V96c0-26.5 21.5-48 48-48h76.6l49.9-36.9C232.2 3.9 243.9 0 256 0s23.8 3.9 33.5 11L339.4 48H416c26.5 0 48 21.5 48 48v44.3l22.1 16.4c14.8 10.9 24.1 27.7 25.7 45.8L416 273.4v-89V144 104.8 96H404.2 368 296.6 215.4zM0 448V242.1L217.6 403.3c11.1 8.2 24.6 12.7 38.4 12.7s27.3-4.4 38.4-12.7L512 242.1V448v0c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v0zM176 160H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z" /></svg> */}
                                <div className="border p-2 rounded-5 new_icon"></div>
                            </span>
                            <span>Emails</span>
                        </Nav.Link>
                    </li>

                    <li>
                        <Nav.Link
                            as={NavLink}
                            to="/admin/transaction"
                            className="d-flex align-items-center w-100 "
                        >
                            <span className="icon">
                            {/* <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-credit-card-2-front-fill" viewBox="0 0 16 16">
  <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2.5 1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-2zm0 3a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm3 0a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm3 0a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm3 0a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z"/>
</svg> */}                   
                                <div className="border p-2 rounded-5 new_icon"></div>
                            </span>
                            <span>Transactions</span>
                        </Nav.Link>
                    </li>

                    <li>
                        <Nav.Link
                            as={NavLink}
                            to="/admin/maintenance"
                            className="d-flex align-items-center w-100"
                        >
                            <span className="icon">
                                {/* <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 512 512" version="1.1" fill="#000000">
                                    <path d="M320,64 L405.333333,149.333333 L405.333333,426.666667 L64,426.666667 L64,64 L320,64 Z M302.326888,106.666667 L106.666667,106.666667 L106.666667,384 L362.666667,384 L362.666667,167.006445 L302.326888,106.666667 Z M256,7.10542736e-15 L298.666667,42.6666667 L42.6666667,42.6666667 L42.6666667,362.666667 L7.10542736e-15,362.666667 L7.10542736e-15,7.10542736e-15 L256,7.10542736e-15 Z M244.302904,167.174593 C260.439702,188.157298 265.883899,213.970305 260.713161,232.815619 C260.06747,235.91652 282.811168,260.09809 328.944255,305.360329 C344.0292,320.445274 344.0292,335.530218 328.944255,350.615163 C314.74666,364.812758 300.549065,365.64791 286.35147,353.120621 L211.482391,282.046388 C192.635434,287.217603 166.823081,281.773415 145.841366,265.636132 C130.452444,245.401095 125.144195,218.951922 129.431109,199.995106 L162.251622,232.815619 L195.072135,216.405362 L211.482391,183.58485 L178.661879,150.764337 C197.618105,146.477784 224.068368,151.785327 244.302904,167.174593 Z" id="Combined-Shape"></path>
                                </svg> */}
                              <div className="border p-2 rounded-5 new_icon"></div>
                               
                            </span>
                            <span>Site Management</span>
                        </Nav.Link>
                    </li>
                   

                    <li>

                  


                    <Nav.Link
                       
                            onClick={ ()=>handleShow() }
                            className="d-flex align-items-center w-100 "
                      
                        >
                           <span className="icon">
                            {/* <svg
                                    width="12"
                                    height="15"
                                    viewBox="0 0 12 15"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M6.68426 7.60306H5.04378C3.70605 7.60306 2.42323 8.13447 1.47726 9.08032C0.531294 10.0263 0 11.3093 0 12.647V13.4649C0 13.872 0.161691 14.2625 0.449565 14.5504C0.737459 14.8383 1.12783 15 1.53506 15H10.1931C10.6003 15 10.9907 14.8383 11.2786 14.5504C11.5665 14.2625 11.7282 13.872 11.7282 13.4649V12.647C11.7282 11.3093 11.1969 10.0263 10.2509 9.08032C9.30494 8.13451 8.02211 7.60306 6.68438 7.60306H6.68426Z"
                                        fill="#333333"
                                    />
                                    <path
                                        d="M5.86368 6.95181C6.78564 6.95181 7.66997 6.58544 8.3218 5.93347C8.97363 5.28153 9.33982 4.3972 9.33966 3.47524C9.33935 2.55312 8.97284 1.66911 8.3207 1.01728C7.6686 0.365605 6.78427 -0.000430388 5.86215 3.79781e-07C4.94019 0.000306303 4.05618 0.366979 3.4045 1.01939C2.75299 1.67165 2.38723 2.55614 2.3877 3.4781C2.38953 4.39916 2.75636 5.28207 3.40787 5.93312C4.05939 6.58432 4.9425 6.95052 5.86368 6.95177V6.95181Z"
                                        fill="#333333"
                                    />
                                </svg> */}
                            <div className="border p-2 rounded-5 new_icon"></div>

                            </span>
                            <span>Logout</span>
                       </Nav.Link>
                    </li>
                </ul>
            </div>
            <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="md"
        centered
      >

        <Modal.Body>
        <Col>
        <img className="modal-img"
            src="/assets/images/exclamation.svg"
            // className="img-fluid"
            alt=""
        />
        <br />
        <br />
        <h3 className="modal-text">Are you sure, you want to Log out?</h3>
        <br />
        <Row className="modal-row">
            <Col md ={1}></Col>
            <Col md={4}>
            <Button className="btn btn-danger danger-btn" onClick={handleClose} >
                    <span><b>Cancel</b></span>
                </Button>
            </Col>
            <Col className="middle-col" md ={2}></Col>
            <Col md={4}>
                <Button className="btn btn-success success-btn" onClick={logout}>
                    
                    <span><b>Confirm</b></span>
                </Button>
             </Col>
            <Col md ={1}></Col>

        </Row>
        <br />
        </Col>
        </Modal.Body>

  </Modal> 

            <Button
                onClick={() => setIsToggled(!isToggled)}
                variant="white"
                className={`sideToggler fullRounded d-flex d-md-none justify-content-center align-items-center p-2  ${isToggled ? 'rotate' : ''} `}
                type="button"
                aria-label="Click to expand sidebar"
                style={{ width: "35px", height: "35px" }}
            >
                <svg
                    width="30px"
                    height="30px"
                    viewBox="0 0 76 76"
                    enableBackground="new 0 0 76.00 76.00"
                >
                    <path
                        fill="#000000"
                        fillOpacity="1"
                        strokeWidth="0.2"
                        strokeLinejoin="round"
                        d="M 35.8724,37.6042L 39.0391,40.7708L 50.5182,51.8542L 40.2266,51.8542L 25.1849,37.6041L 40.2266,23.3542L 50.5182,23.3542L 39.0391,34.4375L 35.8724,37.6042 Z "
                    />
                </svg>
            </Button>
        </div>
    );
};

export default LeftSidebar;
